import { useEffect, useRef, useState } from 'react';
import { AdminSidebar, Icon, Modal } from '../../components/shared';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function AdminCategorias() {
  const [categorias, setCategorias]       = useState([]);
  const [subcategorias, setSubcategorias] = useState([]);
  const [loading, setLoading]             = useState(true);
  const [statusFiltro, setStatusFiltro]   = useState('ativo');
  const [modal, setModal]                 = useState(null); // 'cat' | 'sub'
  const [editingCat, setEditCat]          = useState(null);
  const [editingSub, setEditSub]          = useState(null);
  const [formCat, setFormCat]             = useState({ descricao: '', ordem: 0 });
  const [formSub, setFormSub]             = useState({ descricao: '', categoria_id: '', ordem: 0 });
  const [saving, setSaving]               = useState(false);

  const carregar = async () => {
    setLoading(true);
    try {
      const [cats, subs] = await Promise.all([api.get('/categorias'), api.get('/subcategorias')]);
      setCategorias(cats.data); setSubcategorias(subs.data);
    } catch { toast.error('Erro ao carregar'); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, []);

  const abrirCat = (c = null) => {
    setEditCat(c);
    setFormCat(c ? { descricao: c.descricao, ordem: c.ordem, status: c.status } : { descricao: '', ordem: 0 });
    setModal('cat');
  };
  const abrirSub = (s = null) => {
    setEditSub(s);
    setFormSub(s
      ? { descricao: s.descricao, categoria_id: s.categoria_id, ordem: s.ordem }
      : { descricao: '', categoria_id: categorias[0]?.id || '', ordem: 0 });
    setModal('sub');
  };

  const salvarCat = async () => {
    setSaving(true);
    try {
      if (editingCat) await api.put(`/categorias/${editingCat.id}`, formCat);
      else            await api.post('/categorias', formCat);
      toast.success('Categoria salva!'); setModal(null); carregar();
    } catch (err) { toast.error(err.response?.data?.erro || 'Erro'); }
    finally { setSaving(false); }
  };

  const salvarSub = async () => {
    setSaving(true);
    try {
      if (editingSub) await api.put(`/subcategorias/${editingSub.id}`, formSub);
      else            await api.post('/subcategorias', formSub);
      toast.success('Subcategoria salva!'); setModal(null); carregar();
    } catch (err) { toast.error(err.response?.data?.erro || 'Erro'); }
    finally { setSaving(false); }
  };

  const toggleCat = async (c) => {
    await api.put(`/categorias/${c.id}`, { status: c.status === 'ativo' ? 'inativo' : 'ativo' });
    carregar();
  };

  const excluirCat = async (c) => {
    if (!window.confirm(`Excluir a categoria "${c.descricao}"?`)) return;
    try {
      await api.delete(`/categorias/${c.id}`);
      toast.success('Categoria excluída!');
      carregar();
    } catch (err) { toast.error(err.response?.data?.erro || 'Erro ao excluir'); }
  };

  const categoriasFiltradas = categorias.filter(c => !statusFiltro || c.status === statusFiltro);

  const dragIndex = useRef(null);

  const handleDragStart = (index) => { dragIndex.current = index; };
  const handleDragOver = (e) => { e.preventDefault(); };
  const handleDrop = async (index) => {
    const from = dragIndex.current;
    dragIndex.current = null;
    if (from === null || from === index) return;

    const reordenadas = [...categorias];
    const [movida] = reordenadas.splice(from, 1);
    reordenadas.splice(index, 0, movida);
    setCategorias(reordenadas);

    try {
      await api.put('/categorias/reordenar', { ids: reordenadas.map(c => c.id) });
    } catch {
      toast.error('Erro ao salvar ordem');
      carregar();
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="admin_empresa" />
      <div className="main-content">
        <div className="topbar"><h1>Categorias</h1></div>
        <div className="page-content">
          {loading ? <div className="loading-center"><div className="spinner" /></div> : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>

              {/* CATEGORIAS */}
              <div className="table-card">
                <div className="table-header">
                  <h3>Categorias ({categoriasFiltradas.length})</h3>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <select className="form-control" value={statusFiltro}
                      onChange={e => setStatusFiltro(e.target.value)}
                      style={{ width: '130px' }}>
                      <option value="">Todos status</option>
                      <option value="ativo">Ativas</option>
                      <option value="inativo">Inativas</option>
                    </select>
                    <button className="btn btn-primary btn-sm" onClick={() => abrirCat()}>
                      <Icon name="plus" size={14} /> Nova
                    </button>
                  </div>
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead><tr><th></th><th>Descrição</th><th>Produtos</th><th>Ordem</th><th>Status</th><th></th></tr></thead>
                    <tbody>
                      {categoriasFiltradas.map((c, index) => (
                        <tr key={c.id}
                          draggable={!statusFiltro}
                          onDragStart={() => handleDragStart(index)}
                          onDragOver={handleDragOver}
                          onDrop={() => handleDrop(index)}
                          style={{ cursor: statusFiltro ? 'default' : 'grab' }}>
                          <td style={{ width: '24px', color: 'var(--text-muted)' }}>
                            {!statusFiltro && <Icon name="menu" size={14} />}
                          </td>
                          <td style={{ fontWeight: 600 }}>{c.descricao}</td>
                          <td><span className="badge badge-secondary">{c.total_produtos || 0}</span></td>
                          <td style={{ fontSize: '.85rem' }}>{index + 1}</td>
                          <td>
                            <button onClick={() => toggleCat(c)}
                              title={c.status === 'ativo' ? 'Clique para inativar' : 'Clique para ativar'}
                              className={`badge ${c.status === 'ativo' ? 'badge-success' : 'badge-danger'}`}
                              style={{ border: 'none', cursor: 'pointer' }}>
                              {c.status}
                            </button>
                          </td>
                          <td>
                            <div style={{ display: 'flex', gap: '4px' }}>
                              <button className="btn btn-icon btn-sm" onClick={() => abrirCat(c)}>
                                <Icon name="edit" size={14} />
                              </button>
                              <button className="btn btn-icon btn-sm" onClick={() => excluirCat(c)}
                                style={{ color: 'var(--danger)' }}>
                                <Icon name="trash" size={14} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {!categoriasFiltradas.length && (
                        <tr><td colSpan={6}><div className="empty-state" style={{ padding: '30px' }}>
                          <h3>Nenhuma categoria</h3>
                        </div></td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* SUBCATEGORIAS */}
              <div className="table-card">
                <div className="table-header">
                  <h3>Subcategorias ({subcategorias.length})</h3>
                  <button className="btn btn-primary btn-sm" onClick={() => abrirSub()}>
                    <Icon name="plus" size={14} /> Nova
                  </button>
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead><tr><th>Descrição</th><th>Categoria</th><th>Status</th><th></th></tr></thead>
                    <tbody>
                      {subcategorias.map(s => (
                        <tr key={s.id}>
                          <td style={{ fontWeight: 600 }}>{s.descricao}</td>
                          <td style={{ fontSize: '.85rem', color: 'var(--text-muted)' }}>{s.categoria}</td>
                          <td><span className={`badge ${s.status === 'ativo' ? 'badge-success' : 'badge-danger'}`}>{s.status}</span></td>
                          <td>
                            <button className="btn btn-icon btn-sm" onClick={() => abrirSub(s)}>
                              <Icon name="edit" size={14} />
                            </button>
                          </td>
                        </tr>
                      ))}
                      {!subcategorias.length && (
                        <tr><td colSpan={4}><div className="empty-state" style={{ padding: '30px' }}>
                          <h3>Nenhuma subcategoria</h3>
                        </div></td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal Categoria */}
      <Modal open={modal === 'cat'} onClose={() => setModal(null)} title={editingCat ? 'Editar Categoria' : 'Nova Categoria'}>
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div className="form-group">
            <label className="form-label">Descrição *</label>
            <input className="form-control" value={formCat.descricao}
              onChange={e => setFormCat(p => ({ ...p, descricao: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Ordem de exibição</label>
            <input className="form-control" type="number" value={formCat.ordem}
              onChange={e => setFormCat(p => ({ ...p, ordem: e.target.value }))} />
          </div>
          {editingCat && (
            <div className="form-group">
              <label className="form-label">Status</label>
              <select className="form-control" value={formCat.status}
                onChange={e => setFormCat(p => ({ ...p, status: e.target.value }))}>
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </select>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
          <button className="btn btn-primary" onClick={salvarCat} disabled={saving}>Salvar</button>
        </div>
      </Modal>

      {/* Modal Subcategoria */}
      <Modal open={modal === 'sub'} onClose={() => setModal(null)} title={editingSub ? 'Editar Subcategoria' : 'Nova Subcategoria'}>
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div className="form-group">
            <label className="form-label">Categoria *</label>
            <select className="form-control" value={formSub.categoria_id}
              onChange={e => setFormSub(p => ({ ...p, categoria_id: e.target.value }))}>
              <option value="">Selecione...</option>
              {categorias.map(c => <option key={c.id} value={c.id}>{c.descricao}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Descrição *</label>
            <input className="form-control" value={formSub.descricao}
              onChange={e => setFormSub(p => ({ ...p, descricao: e.target.value }))} />
          </div>
          <div className="form-group">
            <label className="form-label">Ordem</label>
            <input className="form-control" type="number" value={formSub.ordem}
              onChange={e => setFormSub(p => ({ ...p, ordem: e.target.value }))} />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
          <button className="btn btn-primary" onClick={salvarSub} disabled={saving}>Salvar</button>
        </div>
      </Modal>
    </div>
  );
}
